// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_65-6";
export var headerCell = "_65-2";
export var rowWrapper = "_65-4";
export var stickyAggregationCell = "_65-a";
export var stickyAggregationRow = "_65-7";
export var stickyColumnCell = "_65-9";
export var stickyColumnHeaderCell = "_65-8";
export var table = "_65-1";
export var virtualRowWrapper = "_65-5";
export var virtualTableContainer = "_65-0";
export var white = "_65-3";